export const CHECKOUT_URL = 'https://qigong.impultienda.ar/o/front'

export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com'
export const INSTAGRAM_URL = 'https://instagram.com/lumen.akasha'
export const INSTAGRAM_HANDLE = '@lumen.akasha'
export const SITE_URL = 'https://www.lumenakasha.com'

export const BRAND_NAME = 'Lumen Akasha™'
export const PRODUCT_NAME = 'Qigong Mastery Bundle™'
export const PAGE_TITLE =
  'Qigong Mastery Bundle™ | Professional Qigong Teaching System'
export const PAGE_DESCRIPTION =
  '3 professional volumes + 5 practical bonuses for Qigong instructors, therapists and experienced practitioners. Instant digital access — $19 USD.'

export const PRICE = '$19 USD'

export const PACK_IMAGE = {
  src: 'https://cdn.magicpatterns.com/uploads/p5rY9QLpSebzXyskeSQq2a/Qigong_Mockup_Transparent_Gold_Glow.png',
  alt: 'Qigong Mastery Bundle — 3 professional volumes and 5 practical bonuses',
}

export type Volume = {
  n: string
  label: string
  cover: string
  title: string
  subtitle: string
  intro: string
  accent: string
  features: string[]
  closing: string
}

export const volumes: Volume[] = [
  {
    n: 'I',
    label: 'Volume I',
    cover:
      'https://cdn.magicpatterns.com/uploads/9sKTWoiEXfCW9yC1KKCsru/Portada_tomo_1_qi_gong.png',
    title: 'The Professional Qigong Practice System™',
    subtitle: 'Structure, Preparation and Practitioner Protection',
    intro:
      'Build the professional foundation behind every well-led Qigong session.',
    accent: 'text-brand-burgundy',
    features: [
      'Pre-session instructor preparation',
      'Personal readiness and safety checklists',
      'Clear professional boundaries',
      'Session structure from opening to closing',
      'Space and equipment preparation',
      'Participant observation guidelines',
      'Instructor self-assessment tools',
      'Practical methods to reduce improvisation',
      'Professional integration and follow-up',
    ],
    closing:
      'The system that helps you arrive prepared, focused and confident before every session.',
  },
  {
    n: 'II',
    label: 'Volume II',
    cover:
      'https://cdn.magicpatterns.com/uploads/1LK6Vd1QJDNT5UeYhbTb6k/Portada_tomo_2_qi_gong.png',
    title: 'The Ready-to-Teach Qigong Session Library™',
    subtitle:
      '20 Structured Class Blueprints for Confident, Adaptable Delivery',
    intro:
      'Stop starting from a blank page. Choose the right session, review the sequence and begin teaching.',
    accent: 'text-vol-navy',
    features: [
      '20 complete, ready-designed Qigong sessions',
      'Clear intentions and objectives',
      'Suggested duration for each practice',
      'Opening, development and closing phases',
      'Breath, movement and awareness guidance',
      'Teaching cues for every stage',
      'Adaptations for different participants',
      'Common mistakes and corrections',
      'Professional closing recommendations',
    ],
    closing:
      'Ready-designed practices that save preparation time without limiting your teaching style.',
  },
  {
    n: 'III',
    label: 'Volume III',
    cover:
      'https://cdn.magicpatterns.com/uploads/gSATDoZGbLofmyQ8pGJC6B/Portada_tomo_3_qi_gong.png',
    title: 'The Visual Qigong Movement Atlas™',
    subtitle:
      '40 Movement Families With Teaching Cues, Corrections and Adaptations',
    intro:
      'A professional visual reference created for quick consultation before or during your practice planning.',
    accent: 'text-vol-pine',
    features: [
      '40 clearly organized movement families',
      'Step-by-step visual sequences',
      'Body alignment references',
      'Breath and movement coordination',
      'Teaching cues for instructors',
      'Common corrections',
      'Easier and more advanced variations',
      'Adaptations for different bodies',
      'Movement intention and practical application',
    ],
    closing:
      'See the movement. Understand its purpose. Teach it with greater clarity.',
  },
]

export type Bonus = {
  n: string
  title: string
  intro: string
  includes: string[]
}

export const bonuses: Bonus[] = [
  {
    n: 'Bonus 1',
    title: 'Session Quick Builder™',
    intro: 'Create a clear Qigong session without starting from zero.',
    includes: [
      'Session objective planner',
      'Opening, core practice and closing structure',
      'Movement selection spaces',
      'Timing and teaching notes',
      'Quick preparation checklist',
    ],
  },
  {
    n: 'Bonus 2',
    title: 'Qigong Practitioner Assessment and Progress Tracker™',
    intro:
      'Observe each participant and document their development professionally.',
    includes: [
      'Initial practitioner assessment',
      'Posture and mobility observations',
      'Breathing and balance tracking',
      'Energy and stress-level records',
      'Progress notes and follow-up sections',
    ],
  },
  {
    n: 'Bonus 3',
    title: 'Seasonal Qigong Practice Calendar™',
    intro: 'Organize your practices according to the rhythm of each season.',
    includes: [
      'Spring practice planning',
      'Summer practice planning',
      'Autumn practice planning',
      'Winter practice planning',
      'Seasonal intentions and focus areas',
    ],
  },
  {
    n: 'Bonus 4',
    title: 'Qigong Adaptation Guide™',
    intro: 'Adjust your sessions with greater clarity and confidence.',
    includes: [
      'Beginner adaptations',
      'Intermediate alternatives',
      'Advanced variations',
      'Seated and supported options',
      'Mobility-conscious modifications',
    ],
  },
  {
    n: 'Bonus 5',
    title: 'Professional Student Forms and Trackers™',
    intro: 'Keep your classes, participants and observations organized.',
    includes: [
      'Student information forms',
      'Attendance records',
      'Session notes',
      'Progress trackers',
      'Instructor follow-up sheets',
    ],
  },
]

export const valueSummary = [
  'The Professional Qigong Practice System™',
  'The Ready-to-Teach Qigong Session Library™',
  'The Visual Qigong Movement Atlas™',
  'Session Quick Builder™',
  'Practitioner Assessment and Progress Tracker™',
  'Seasonal Qigong Practice Calendar™',
  'Qigong Adaptation Guide™',
  'Professional Student Forms and Trackers™',
]

export const painPoints = [
  'You spend too much time planning every class',
  'You repeat the same sequences because they feel familiar',
  'You struggle to choose the right practice for each group',
  'You improvise teaching cues during the session',
  'You forget important adaptations',
  'You lack a clear way to monitor progress',
  'Your valuable knowledge remains scattered',
  'You finish classes wondering what could have been clearer',
]

export const comparison = {
  before: [
    'Planning from a blank page',
    'Searching through scattered notes',
    'Repeating the same practices',
    'Uncertainty when adapting movements',
    'Limited session records',
    'Too much unnecessary preparation',
  ],
  after: [
    'Ready-designed session structures',
    'A visual movement reference',
    'Clear teaching cues',
    'Practical adaptations',
    'Professional forms and trackers',
    'More confident and consistent delivery',
  ],
}

export const audience = [
  'Qigong instructors',
  'Wellness therapists',
  'Holistic practitioners',
  'Movement and breathwork facilitators',
  'Experienced Qigong students',
  'Professionals who guide individual or group practices',
  'Practitioners who want organized reference material',
]

export const benefits = [
  {
    title: 'Prepare Faster',
    text: 'Choose a session structure, review the sequence and focus your time on the people you are guiding.',
  },
  {
    title: 'Teach With Confidence',
    text: 'Use clear visual references, teaching cues and corrections to communicate every practice more effectively.',
  },
  {
    title: 'Adapt With Clarity',
    text: 'Access variations and practical alternatives for different levels, abilities and class formats.',
  },
]

export const faqs = [
  {
    q: 'Who is this bundle designed for?',
    a: 'It was created for Qigong instructors, therapists and experienced practitioners who want more structure, visual clarity and professional tools.',
  },
  {
    q: 'Is it suitable for complete beginners?',
    a: 'The material is designed mainly for people who already have some Qigong training or practice experience. It does not replace formal instructor certification.',
  },
  {
    q: 'What exactly will I receive?',
    a: 'You will receive three main digital volumes and five additional practical bonuses in downloadable PDF format.',
  },
  {
    q: 'How will I receive the material?',
    a: 'Immediately after payment, the download information will be sent automatically to the email address you entered during checkout.',
  },
  {
    q: 'Do I need to print everything?',
    a: 'No. You can read and consult the materials from your phone, tablet or computer. You may print the pages you want to use during planning or teaching.',
  },
  {
    q: 'Is the material in English?',
    a: 'Yes. The complete Qigong Mastery Bundle™ is written in English.',
  },
  {
    q: 'Can I access it from any country?',
    a: 'Yes. It is a fully digital product and can be downloaded worldwide.',
  },
  {
    q: 'Is this a subscription?',
    a: 'No. You make one payment of $19 USD. There are no monthly fees.',
  },
  {
    q: 'Can I use it with individual students and groups?',
    a: 'Yes. The tools can support both individual and group practices, depending on your training, professional scope and each participant’s needs.',
  },
  {
    q: 'Does this material replace medical care or professional training?',
    a: 'No. It is educational material for trained practitioners and does not replace medical advice, diagnosis, treatment or professional certification.',
  },
  {
    q: 'Does my purchase include a guarantee?',
    a: 'Yes. Your purchase is covered by a seven-day satisfaction guarantee.',
  },
]

export const costs = [
  {
    without: 'Without a session structure',
    cost: 'Every class begins with another blank page.',
  },
  {
    without: 'Without a visual movement library',
    cost: 'Your valuable knowledge stays scattered across different sources.',
  },
  {
    without: 'Without ready-designed practices',
    cost: 'Preparation takes longer than it should.',
  },
  {
    without: 'Without adaptation tools',
    cost: 'You hesitate when participants need alternatives.',
  },
  {
    without: 'Without teaching cues',
    cost: 'Clear movements become difficult to explain.',
  },
  {
    without: 'Without professional trackers',
    cost: 'Progress and important observations are easily forgotten.',
  },
  {
    without: 'Without an organized system',
    cost: 'You continue investing time in work that could already be prepared.',
  },
]

export const finalIncludes = [
  '3 professional Qigong volumes',
  '5 practical bonuses',
  '20 ready-designed sessions',
  '40 visual movement families',
  'Teaching cues and corrections',
  'Adaptation tools',
  'Student forms and trackers',
  'Instant digital access',
  '7-day guarantee',
]
